import { Plus, Users } from 'lucide-react';
import { ShortcutButton } from '@/components/keyboard/ShortcutIndicator';

interface InvestorsEmptyStateProps {
  hasFilters: boolean;
  hasInvestors: boolean;
  onNewInvestor: () => void;
}

function getEmptyMessage({
  hasFilters,
  hasInvestors,
}: Pick<InvestorsEmptyStateProps, 'hasFilters' | 'hasInvestors'>) {
  if (hasFilters) return 'Try adjusting your filters or search terms.';
  if (!hasInvestors) return 'Get started by adding your first investor.';
  return 'No investors match your criteria.';
}

export function InvestorsEmptyState({
  hasFilters,
  hasInvestors,
  onNewInvestor,
}: InvestorsEmptyStateProps) {
  return (
    <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
      <Users className="mx-auto h-12 w-12 text-gray-400" />
      <h3 className="mt-2 text-sm font-medium text-gray-900">
        No investors found
      </h3>
      <p className="mt-1 text-sm text-gray-500">
        {getEmptyMessage({ hasFilters, hasInvestors })}
      </p>
      {!hasFilters && !hasInvestors && (
        <div className="mt-6">
          <ShortcutButton
            shortcut={{ key: 'n' }}
            className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
            onClick={onNewInvestor}
          >
            <Plus className="h-4 w-4" />
            Add Investor
          </ShortcutButton>
        </div>
      )}
    </div>
  );
}
